module.exports = __webpack_public_path__ + "img/data-zhTc.6414cd53.png";